// extracted by mini-css-extract-plugin
export var cancelButton = "_ll-5";
export var content = "_ll-3";
export var createButton = "_ll-6";
export var drawerContainer = "_ll-0";
export var footer = "_ll-2";
export var header = "_ll-1";
export var orderFormColumn = "_ll-4";